import { useHtmlSnippetQuery } from "@/hooks";
import { memo, useState, useEffect, useRef } from "react";

function HtmlSnippet({ id, idKey }) {
  const snippet = useRef();
  const [html, setHtml] = useState("");
  const { data } = useHtmlSnippetQuery({
    variables: { id, idKey },
  });

  const { content, style, javascript } = data?.htmlSnippet || {};
  useEffect(() => {
    if (snippet.current) {
      let _html = "";
      if (style) {
        _html += `<style>${style}</style>`;
      }
      if (content) {
        _html += `${content}`;
      }
      setHtml(_html);

      if (javascript) {
        const scriptEl = document.createElement("script");
        scriptEl.type = "text/javascript";
        scriptEl.async = true;
        scriptEl.innerHTML = `
      (function () {
        try {
          ${javascript}
        } catch (e) {
          console.error(e);
        }
      }());`;

        snippet.current.appendChild(scriptEl);
      }
    }
  }, [snippet.current, content, style, javascript]);

  return (
    <div className={`snippet-${id}`} ref={snippet}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}

export default memo(HtmlSnippet);
